<template>
  <HScaffold title="地址管理">
    <div class="tAddressParentDiv">
      <div v-if="useUser.addressList.length>0"
           style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <div :style="hcf.getTextStyle({
          color:'#aaa'
        })">收货地址：
        </div>
        <div :style="hcf.getTextStyle({
           color:'main'
        })">{{ useUser.addressList.length }}
        </div>
        <div :style="hcf.getTextStyle({
          color:'#aaa'
        })">/3个 (最多添加3个地址)
        </div>
      </div>
      <HNullSpace v-if="useUser.addressList.length<=0" siz="80" title="暂未添加收货地址"/>
      <div v-if="useUser.addressList.length>0"
           style="display: flex;flex-direction: column;">
        <div v-for="item in useUser.addressList" :key="item.Id"
             class="eachBlockDiv"
             :style="{
                backgroundColor:HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white',
             }">
          <div style="display: flex;flex-direction: row;">
            <div :style="hcf.getTextStyle({
            addSize:1,
          })">{{ item.Name }}
            </div>
            <div :style="hcf.getTextStyle({
              marginLeft:20,marginRight:10,addSize:1,
          })">{{ item.Mobile }}
            </div>
          </div>
          <div :style="hcf.getTextStyle({
            color:'#aaa'
          })">城市：{{ item.City }}
          </div>
          <div :style="hcf.getTextStyle({
            color:'#aaa'
          })">详细地址：{{ item.Address }}
          </div>
          <van-divider style="margin:7px;"/>
          <div style="display: flex;flex-direction: row;align-items: center;">
            <van-checkbox @click="changeIsDefault(item)" :checked="item.Default" icon-size="16px"
                          style="font-size: 13px;">默认地址
            </van-checkbox>
            <div style="flex:1"/>
            <div @click="editAddress(item)" style="display: flex;flex-direction: row;align-items: center;">
              <van-icon name="edit" style="margin-right:5px" :color="HNewGameUIConfig.newGameUIType === 3?'#fff':''"/>
              <div :style="hcf.getTextStyle()">编辑</div>
            </div>
          </div>
        </div>
      </div>
      <HButton :callback="addAddress" title="新增收获地址"/>
      <div v-if="useUser.addressList.length<=0" :style="hcf.getTextStyle({
      textAlign:'center'
      })">最多支持添加3个收货地址
      </div>
    </div>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import HNullSpace from "@/components/utils/HNullSpace.vue";
  import HButton from "@/components/utils/HButton.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  let useUser = useUserStore();
  let useHttp = useHHttp();

  let isChangeDefaultIsPosting = false;

  function changeIsDefault(item) {
    useHttp.request(
        "/app/profile/modify-delivery",
        (data) => {
          isChangeDefaultIsPosting = false;
          data["Data"].sort((a, b) => b["Default"] - a["Default"]);
          useUser.addressList = data["Data"];
        }, {
          params: {
            "Id": item["Id"],
            "UserId": useUser.userId,
            "Default": 1,
          }
        });
  }

  function editAddress(item) {
    hr.go("edit-address", {isModify: true, data: item});
  }

  function addAddress() {
    hr.go("edit-address", {isModify: false});
  }
</script>


<style scoped>

  .tAddressParentDiv {
    display: flex;
    flex-direction: column;
    padding: 10px;
  }

  .eachBlockDiv {
    margin-bottom: 10px;
    padding: 10px;
    border-radius: 10px;
  }
</style>
